import { render, staticRenderFns } from "./Interes_Simple_S_Uno.vue?vue&type=template&id=ed867b66&scoped=true&"
import script from "./Interes_Simple_S_Uno.vue?vue&type=script&lang=js&"
export * from "./Interes_Simple_S_Uno.vue?vue&type=script&lang=js&"
import style0 from "./Interes_Simple_S_Uno.vue?vue&type=style&index=0&id=ed867b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed867b66",
  null
  
)

export default component.exports